import { SERVICES_RENDERED_PAYMENT_INITIAL } from './constants';

/**
 * The datetime for a status row written from the services-rendered form.
 *
 * The form's Date Processed starts from SERVICES_RENDERED_PAYMENT_INITIAL, whose time is taken
 * once, when the module loads. Used as the row's datetime whenever the form was touched, it
 * stamped a Completed or Incomplete row with the page-load time, so the row was outranked by
 * the visit's earlier rows and ServiceChannel could get that stale time as the check-out time
 * (FU1.2). A date the user actually changed is kept; anything else is now.
 */
export const statusRowDatetime = (dateProcessed: string, now: string): string =>
  dateProcessed && dateProcessed !== SERVICES_RENDERED_PAYMENT_INITIAL.dateProcessed
    ? dateProcessed
    : now;
